export function getFacet(
  state,
) {
  return ( facet ) => {
    return (
      state.items[facet] ||
      null
    );
  };
}

export function applicableCount(
  state,
) {
  return ( facet ) => {
    return (
      state.items[facet]
        ?.options
        ?.length ||
      0
    );
  };
}

export function countsWithheld(
  state,
) {
  return ( facet ) => {
    const item =
      state.items[facet];

    return !!(
      item &&
      item.error &&
      item.loadedOnce
    );
  };
}
